import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const financeProfitTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "finance.profit-trend",
  name: "Revenue and profit trends",
  description: "Posted net revenue and net profit by accounting date.",
  apps: [
    "home",
    "finance",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "finance.journal-items",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "balance",
          as: "profit",
        },
      ],
      where: {
        type: "group",
        operator: "or",
        children: [
          {
            type: "condition",
            field: "account_type",
            operator: "starts_with",
            value: "income",
          },
          {
            type: "condition",
            field: "account_type",
            operator: "starts_with",
            value: "expense",
          },
        ],
      },
    },
    graphQueries: [
      {
        name: "Revenue",
        query: {
          version: 1,
          source: "finance.journal-items",
          ...period(30),
          select: [
            {
              type: "field",
              field: "accounting_date",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "sum",
              field: "balance",
              as: "revenue",
            },
          ],
          group_by: [
            {
              field: "accounting_date",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
          where: {
            type: "condition",
            field: "account_type",
            operator: "starts_with",
            value: "income",
          },
        },
        type: "area",
        color: "#206bc4",
        lineWidth: 2,
        fillOpacity: 0.12,
        valueMultiplier: -1,
      },
      {
        name: "Profit",
        query: {
          version: 1,
          source: "finance.journal-items",
          ...period(30),
          select: [
            {
              type: "field",
              field: "accounting_date",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "sum",
              field: "balance",
              as: "profit",
            },
          ],
          where: {
            type: "group",
            operator: "or",
            children: [
              {
                type: "condition",
                field: "account_type",
                operator: "starts_with",
                value: "income",
              },
              {
                type: "condition",
                field: "account_type",
                operator: "starts_with",
                value: "expense",
              },
            ],
          },
          group_by: [
            {
              field: "accounting_date",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "line",
        color: "#2fb344",
        lineWidth: 2,
        valueMultiplier: -1,
      },
    ],
  },
  inputs: {
    title: "Revenue and profit trends",
    valueFormat: "currency",
    valueMultiplier: -1,
    graphPadding: true,
    chartHeight: 112,
    curve: "smooth",
  },
  dummyData: {
    value: "$14,400",
    series: [
      18,
      24,
      20,
      32,
      29,
      41,
      48,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
